import { render } from "./MdUpwardIcon.vue?vue&type=template&id=00614a2e"
import script from "./MdUpwardIcon.vue?vue&type=script&lang=js"
export * from "./MdUpwardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__